import { ITextStyles, ITooltipHostStyles, Label, mergeStyleSets, Text, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import fascicoliService from '../../services/fascicoli.service';
import { Fascicolo_Type, Fascicolo_Type_Label } from '../../shared/enums';
import { IFascicolo, IField } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';
import { RootState } from '../../store';
import { toastRef } from '../Layout/Layout';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';


const classNames = mergeStyleSets({
    inputWrapper:
    {
        paddingBottom: '20px',
    },

    pad: {
        paddingTop: '20px',
    },
});

const tooltipHostStyles: Partial<ITooltipHostStyles> = {
    root: {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'

    }
};



const textStyle: Partial<ITextStyles> = {

    root: {
        paddingLeft: 8,
        paddingRight: 8,
    }
};
export interface DettagliFascicoloProps {
    currentFascicolo: IFascicolo
    currentFascicoloIndex?: number
    loadingDettagliFascicolo: boolean
}

const DettagliFascicolo: React.FunctionComponent<DettagliFascicoloProps> = (props) => {


    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState<any[]>([]);




    useEffect(() => {
        setLoading(props.loadingDettagliFascicolo);
    }, [props.loadingDettagliFascicolo]);

    useEffect(() => {
        let selectedFascicolo: IFascicolo = { ...props.currentFascicolo };
        const proprietaFascicolo = [
            {
                key: "tipoFascicolo",
                name: "Tipo Fascicolo",
                value: Fascicolo_Type_Label.get(selectedFascicolo.tipoFascicolo)
            },
            {
                key: "responsabile",
                name: "Responsabile",
                value: selectedFascicolo.responsabile
            },
            {
                key: "descrizione",
                name: "Descrizione",
                value: selectedFascicolo.descrizione
            },
            {
                key: "titolarioLabel",
                name: "Titolario",
                value: selectedFascicolo.titolarioLabel
            },
            {
                key: "dataApertura",
                name: "Data Apertura",
                value: AppUtilities.FormatDate(selectedFascicolo.dataApertura, true)
            }
        ]

        if (selectedFascicolo.dataChiusura)
        {
            proprietaFascicolo.push({
                key: "dataChiusura",
                name: "Data Chiusura",
                value: AppUtilities.FormatDate(selectedFascicolo.dataChiusura, true)
            })
        }

        if (selectedFascicolo.tipoFascicolo === Fascicolo_Type.Attivita) {
            proprietaFascicolo[0].value = "Attivit\u00e0";

        }
        setItems(proprietaFascicolo);
    }, [props.currentFascicolo]);


    /*Object.entries(response).map(([key, value]) => {*/
    //    const columnName: IColumn = {
    //        key: key,
    //        name: "name",
    //        fieldName: key,
    //        minWidth: 200,
    //        className: classNames.nameText,
    //        isResizable: true,
    //        onRender: (item) => <span>{item.key}</span>,
    //    };

    //    const columnValue: IColumn = {
    //        key: value,
    //        name: "value",
    //        fieldName: value,
    //        minWidth: 300,
    //        isMultiline: true,
    //        onRender: (item) => <span>{item[key]}</span>,
    //    };

    //    dynamicColumns.push(columnName, columnValue);
    //});

    //setColumns(dynamicColumns);

    return (
        <div className={`position-relative my-scroll-div`}>
            <div className={classNames.pad}>

                <CircleLoader loaderClass='loader-large' loading={loading} />

                {
                    items.map((item) => {
                        return (
                            <div className={classNames.inputWrapper}>
                                <Label>{item.name}</Label>
                                <TooltipHost
                                    content={item.value}
                                    styles={tooltipHostStyles}
                                    overflowMode={TooltipOverflowMode.Self}
                                >
                                    <Text styles={textStyle} >
                                        {item.value}
                                    </Text>
                                </TooltipHost>


                            </div>
                        )
                    }

                    )
                }
            </div>
        </div>

    )
}

export default DettagliFascicolo;